import styled from 'styled-components';
import { Form } from 'antd';

const CustomFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`;

export default CustomFormItem;
